import { z } from 'zod';

export const zodUploadSupplierLetterRequestSchema = z.object({
  fileId: z.uuid(),
  fileMime: z.string(),
  fileName: z.string(),
});
